/* eslint-disable import/prefer-default-export */
import { SHOW_HIDE_COVID_BCP_ALERT } from '../constants/ActionTypes';

export const showHideCovidBcpModalAlert = (value) => (dispatch) => dispatch({
  type: SHOW_HIDE_COVID_BCP_ALERT,
  payload: value,
});
